module.exports = __webpack_public_path__ + "img/47.f8bfb1c2.webp";